import React, { useEffect, useMemo, useState } from 'react';
import { Chart } from 'react-google-charts';
import { useParams } from 'react-router-dom';
import useApiManager from 'networking/ApiManager';
import { CoreDropDown } from 'whealth-core-web/components';
import { dateFormatString, subtractMonths } from 'whealth-core-web/components/Helper';

const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const options = {
  legend: 'none',
  pointSize: 8,
  curveType: 'function',
  interpolateNulls: true,
  vAxis: {
    viewWindow: { min: 0, max: 10 },
    baseline: 0,
    format: '#',
    ticks: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    textStyle: {
      fontSize: 10,
    },
  },
  hAxis: {
    textStyle: {
      fontSize: 10,
    },
  },
  chartArea: {
    width: '80%',
    height: '70%',
    left: 50,
  },
};

const durationData = [
  { title: '1 Year', id: dateFormatString(new Date(subtractMonths(11, new Date())).setDate(1)) },
  { title: '6 Months', id: dateFormatString(new Date(subtractMonths(5, new Date())).setDate(1)) },
  { title: '3 Months', id: dateFormatString(new Date(subtractMonths(2, new Date())).setDate(1)) },
  { title: '1 Month', id: dateFormatString(subtractMonths(1, new Date())) },
];

function PainCalendarGraph() {
  const { id } = useParams();
  const ApiClient = useApiManager();
  const [monthlyData, setMonthlyData] = useState([]);
  const [dateValue, setDateValue] = useState(durationData[1].id);

  useEffect(() => {
    ApiClient.painCalendar(id, { date_range: dateValue })
      .then((res) => {
        setMonthlyData(res.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id, dateValue]);

  const chartData = useMemo(() => {
    const rows = [['Date', 'Pain']];
    monthlyData.forEach((monthBucket) => {
      if (monthBucket?.records?.length) {
        monthBucket.records.forEach((record) => {
          const recordDate = new Date(record.date);
          rows.push([`${monthNames[recordDate.getMonth()]} ${recordDate.getDate()}`, record.pain]);
        });
      } else {
        rows.push([monthBucket?.month, null]);
      }
    });
    return rows;
  }, [monthlyData]);

  const getChartWidth = () => {
    const pointCount = Math.max(chartData.length - 1, 1);
    const widthPerPoint = 45;
    const computedWidth = pointCount * widthPerPoint;
    return `${Math.max(computedWidth, 400)}px`;
  };

  return (
    <div className='d-md-flex mb-3'>
      <div className='card w-100 weight-card no-border'>
        <div className='card-body' style={{ overflowX: 'auto' }}>
          <div className='d-flex'>
            <div className='flex-grow-1'>
              <h5 className='card-title'>Pain Calendar</h5>
            </div>
            <div className='ms-auto'>
              <CoreDropDown value={dateValue} setValue={setDateValue} data={durationData} />
            </div>
          </div>
          <div className='d-flex' style={{ width: getChartWidth(), overflowX: 'auto' }}>
            <Chart chartType='LineChart' data={chartData} options={options} width={getChartWidth()} height='300px' />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PainCalendarGraph;
